import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class DepartmentsService {
  constructor(private http: HttpClient) {
  }

  fetch(id: string, params?: {}): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/departments/${id}`, {params: params});
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/api/departments/${id}`);
  }

}
